import { render } from "./ArvorePropertiesComponent.vue?vue&type=template&id=74d3b786"
import script from "./ArvorePropertiesComponent.vue?vue&type=script&lang=js"
export * from "./ArvorePropertiesComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\agilS\\agil.webgisprod\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__